import { createTheme } from '@mui/material/styles';
import { colors } from './colors';

export const selectDarkTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary.yellow,
    },
    text: {
      primary: colors.primary.white,
      secondary: colors.primary.white,
    },
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: colors.primary.white,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.background.primary,
          border: `1px solid ${colors.background.secondary}`,
          borderRadius: '8px',
          marginTop: '4px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: colors.primary.white,
          backgroundColor: colors.background.primary,
          '&:hover': {
            backgroundColor: colors.background.secondary,
          },
          '&.Mui-selected': {
            backgroundColor: colors.primary.yellow,
            color: colors.background.primary,
            '&:hover': {
              backgroundColor: colors.primary.yellow,
              color: colors.background.primary,
            },
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.background.primary,
          border: `1px solid ${colors.background.secondary}`,
          borderRadius: '8px',
          marginTop: '4px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: colors.primary.white,
          '&.Mui-focused': {
            color: colors.primary.yellow,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.primary,
          color: colors.primary.white,
          '& fieldset': {
            borderColor: colors.background.secondary,
            borderWidth: '1px',
          },
          '&:hover fieldset': {
            borderColor: colors.primary.yellow,
            borderWidth: '2px',
          },
          '&.Mui-focused fieldset': {
            borderColor: colors.primary.yellow,
            borderWidth: '2px',
          },
          '&:hover': {
            '& fieldset': {
              borderColor: colors.primary.yellow,
              borderWidth: '2px',
            },
          },
        },
        input: {
          color: colors.primary.white,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: 2,
          '& .MuiFormHelperText-root': {
            color: colors.primary.warning,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: colors.background.primary,
            color: colors.primary.white,
            '& fieldset': {
              borderColor: colors.background.secondary,
              borderWidth: '1px',
            },
            '&:hover fieldset': {
              borderColor: colors.primary.yellow,
              borderWidth: '2px',
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.primary.yellow,
              borderWidth: '2px',
            },
            '&:hover': {
              '& fieldset': {
                borderColor: colors.primary.yellow,
                borderWidth: '2px',
              },
            },
          },
          '& .MuiSelect-select': {
            color: colors.primary.white,
          },
          '& .MuiInputLabel-root': {
            color: colors.background.secondary,
            '&.Mui-focused': {
              color: colors.primary.yellow,
            },
          },
          '& .MuiSvgIcon-root': {
            color: colors.primary.white,
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: colors.primary.yellow,
            },
            '&:hover fieldset': {
              borderColor: colors.primary.yellow,
              borderWidth: '2px',
            },
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          '& .MuiPaper-root': {
            backgroundColor: colors.background.primary,
            border: `1px solid ${colors.background.secondary}`,
            borderRadius: '8px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '&.MuiPickersPopper-paper': {
            backgroundColor: colors.background.primary,
            border: `1px solid ${colors.background.secondary}`,
            borderRadius: '8px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiPickersDay-root': {
            color: colors.primary.white,
            backgroundColor: colors.background.primary,
            '&:hover': {
              backgroundColor: colors.background.secondary,
            },
            '&.Mui-selected': {
              backgroundColor: colors.primary.yellow,
              color: colors.background.primary,
              '&:hover': {
                backgroundColor: colors.primary.yellow,
                color: colors.background.primary,
              },
            },
            '&.MuiPickersDay-today': {
              border: `2px solid ${colors.primary.yellow}`,
            },
          },
        },
      },
    },
  },
});
